<template>
  <!-- Header -->
  <div class="header" :class="windowWidth < 700 ? 'fixed-header' : ''">
    <a href="javascript:void(0);" id="toggle_btn" @click="toggleMenu">
      <i class="fas fa-align-left"></i>
    </a>
    <a class="mobile_btn" id="mobile_btn" href="javascript:void(0);">
      <i class="fas fa-align-left"></i>
    </a>
    <ul class="nav user-menu">
      <li class="nav-item dropdown business-picker-container" ref="businessesContainer">
        <multiselect
          @input="handleContextChange"
          @remove="handleRemove"
          v-model="selected"
          :options="contexts"
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="false"
          :show-labels="false"
          placeholder="Select customer context"
          label="displayName"
          track-by="contextId"
          class="custom-multiselect"
        >
        </multiselect>
        <!--        <span class="badge badge-info mt-1" style="padding: 6px">v1.0.0</span>-->
      </li>

      <!-- User Menu -->
      <li class="nav-item dropdown mt-1" ref="userMenuContainer">
        <a href="javascript:void(0)" class="dropdown-toggle user-link nav-link" @click="toggleUserMenu">
          <i class="far fa-user"></i>
        </a>
        <div v-if="showUserMenu" class="modern-dropdown" @click.stop>
          <div class="dropdown-header">
            <i class="fas fa-user-circle"></i>
            <span class="user-email-text">{{ currentUserEmail }}</span>
          </div>
          <router-link v-if="isAllowed('INVOICES_READ')" class="dropdown-item modern-item"
                       :to="`/settings/account`" @click.native="closeUserMenu">
            <i class="fas fa-user-cog"></i>
            <span>Account</span>
          </router-link>
          <a class="dropdown-item modern-item logout-item" href="javascript:void(0);" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
      <!-- /User Menu -->

    </ul>
  </div>
  <!-- /Header -->
</template>

<script>
import jwtDecode from "jwt-decode";
import Multiselect from 'vue-multiselect'
import {allowedModules} from "../../utils/modules";

export default {
  name: "top-header",
  components: {Multiselect},
  data() {
    return {
      selectedContextId: null,
      contexts: [],
      selected: null,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      showUserMenu: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserEmail() {
      const userToken = localStorage.getItem('user');
      if (!userToken) {
        return;
      }
      let user = JSON.parse(userToken);
      return user.email
    },
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    basedOnWindowWidth() {
      if (this.windowWidth > 768) {
        return true;
      }
      return false;
    }
  },
  methods: {
    isAllowed(permission) {
      return true
      // return this.permissions.includes(permission)
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    closeUserMenu() {
      this.showUserMenu = false;
    },
    handleClickOutside(event) {
      const userMenuContainer = this.$refs.userMenuContainer;
      if (userMenuContainer && !userMenuContainer.contains(event.target)) {
        this.showUserMenu = false;
      }
    },
    logout() {
      this.closeUserMenu();
      this.$store.dispatch('auth/logout')
      this.$router.push('/login');
      // location.reload();
    },
    loadCustomerContexts() {
      const userToken = localStorage.getItem('user');
      if (!userToken) {
        return;
      }
      
      let user = JSON.parse(userToken);
      
      // Get contexts from login response stored in localStorage
      if (user.availableContexts) {
        // Filter for CUSTOMER_CONTACT contexts
        this.contexts = user.availableContexts.filter(
          context => context.actorType === 'CUSTOMER_CONTACT'
        );
        
        // Set selected context from localStorage
        const selectedContextId = localStorage.getItem('selectedContextId');
        if (selectedContextId && this.contexts.length) {
          this.selected = this.contexts.find(ctx => ctx.contextId === selectedContextId);
        } else if (this.contexts.length > 0) {
          // Default to first context if none selected
          this.selected = this.contexts[0];
        }
        
        if (this.contexts.length === 0) {
          console.warn('No customer contexts found');
        }
      }
    },
    toggleMenu() {
      if (document.body.classList.contains('expand-menu')) {
        document.body.classList.remove('expand-menu')
        document.body.classList.add('mini-sidebar')
        localStorage.setItem('isExpandedMenu', JSON.stringify(false));
        this.$store.dispatch('app/setIsExpandedMenu', false)
      } else {
        document.body.classList.remove('mini-sidebar')
        document.body.classList.add('expand-menu')
        localStorage.setItem('isExpandedMenu', JSON.stringify(true));
        this.$store.dispatch('app/setIsExpandedMenu', true)
      }
    },
    goToSettings() {
      this.$router.push(`/businesses/${this.selectedStoreId}/general-information`);
    },
    handleRemove(selectedOption) {
      this.selected = selectedOption;
    },
    
    async handleContextChange(selectedContext) {
      if (selectedContext && selectedContext.contextId) {
        // Store the selected context
        localStorage.setItem('selectedContext', JSON.stringify(selectedContext));
        localStorage.setItem('selectedContextId', selectedContext.contextId);
        localStorage.setItem('contextId', selectedContext.contextId);
        localStorage.setItem('actorId', selectedContext.actorId);
        localStorage.setItem('mid', selectedContext.contextId); // Use contextId as merchant ID
        localStorage.setItem('displayName', selectedContext.displayName);
        localStorage.setItem('contactType', selectedContext.description || '');
        
        const profile = allowedModules.filter(module => module.name === this.$i18n.locale)[0];
        await localStorage.setItem("homeUrl", profile.dashboardUrl);
        
        // Reload the dashboard
        if (this.$route.path === '/' || this.$route.path.includes('dashboard')) {
          await this.$nextTick(() => {
            window.location.reload();
          });
        } else {
          console.log('Redirecting to root from header...');
          await this.$router.push('/');
        }
      }
    },
    fireNotification(icon, message, timeout) {
      Swal.fire({
        toast: true,
        width: 300,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: timeout,
        timerProgressBar: true,
      })
    }
  },
  watch: {
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    }
  },

  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    }

    this.loadCustomerContexts();

    this.selectedContextId = localStorage.getItem('selectedContextId');
    
    // Add click outside listener for user menu
    document.addEventListener('click', this.handleClickOutside);

    var $wrapper = $('.main-wrapper');
    var $pageWrapper = $('.page-wrapper');
    var $slimScrolls = $('.slimscroll');

    var Sidemenu = function () {
      this.$menuItem = $('#sidebar-menu a');
    };

    function init() {
      var $this = Sidemenu;
      $('#sidebar-menu a').on('click', function (e) {
        if ($(this).parent().hasClass('submenu')) {
          e.preventDefault();
        }
        if (!$(this).hasClass('subdrop')) {
          $('ul', $(this).parents('ul:first')).slideUp(350);
          $('a', $(this).parents('ul:first')).removeClass('subdrop');
          $(this).next('ul').slideDown(350);
          $(this).addClass('subdrop');
        } else if ($(this).hasClass('subdrop')) {
          $(this).removeClass('subdrop');
          $(this).next('ul').slideUp(350);
        }
      });
      $('#sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');
    }

    init();

    $('body').append('<div class="sidebar-overlay"></div>');
    $(document).on('click', '#mobile_btn', function () {
      $wrapper.toggleClass('slide-nav');
      $('.sidebar-overlay').toggleClass('opened');
      // $('html').addClass('menu-opened');
      return false;
    });

    $(".sidebar-overlay").on("click", function () {
      $wrapper.removeClass('slide-nav');
      $(".sidebar-overlay").removeClass("opened");
      $('html').removeClass('menu-opened');
    });

    // $(document).on('click', '#toggle_btn', function () {
    //   if ($('body').hasClass('mini-sidebar')) {
    //     $('body').removeClass('mini-sidebar');
    //     $('.subdrop + ul').slideDown();
    //   } else {
    //     $('body').addClass('mini-sidebar');
    //     $('.subdrop + ul').slideUp();
    //   }
    //   setTimeout(function () {
    //     mA.redraw();
    //     mL.redraw();
    //   }, 300);
    //   return false;
    // });

    $(document).on('mouseover', function (e) {
      e.stopPropagation();
      // if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
      //   var targ = $(e.target).closest('.sidebar').length;
      //   if (targ) {
      //     $('body').addClass('expand-menu');
      //     $('.subdrop + ul').slideDown();
      //   } else {
      //     $('body').removeClass('expand-menu');
      //     $('.subdrop + ul').slideUp();
      //   }
      //   return false;
      // }
      $(window).scroll(function () {
        const windowWidth = $(window).width(); // Get the current window width
        if (windowWidth < 575) {
          // If window width is less than 500px, always apply the fixed-header class
          $('.header').addClass('fixed-header');
        } else {
          // If window width is greater than or equal to 500px, apply/remove the class based on scroll position
          if ($(window).scrollTop() >= 1) {
            $('.header').addClass('fixed-header');
          } else {
            $('.header').removeClass('fixed-header');
          }
        }
      });
      // $(window).scroll(function () {
      //   if (($(window).scrollTop() >= 1)) {
      //     $('.header').addClass('fixed-header');
      //   }
      //   else if(this.windowWidth < 500){
      //     $('.header').addClass('fixed-header');
      //     $(window).scrollTop() == 0
      //   }
      //   else {
      //     $('.header').removeClass('fixed-header');
      //   }
      // });

      $(document).on('click', '#loginSubmit', function () {
        $("#adminSignIn").submit();
      });
    });
  },
  beforeDestroy() {
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.custom-multiselect .multiselect__content-wrapper {
  width: 100%; /* Fills the parent container */
}

.custom-multiselect .multiselect__tags {
  border: 1px solid #ddd;
}
</style>

<style scoped>
@media (max-width: 768px) {
  .business-picker-container {
    display: none;
  }
}



/* Modern Dropdown Menu */
.modern-dropdown {
  position: fixed;
  top: 115px;
  right: 50px;
  min-width: 280px;
  max-width: 280px;
  border: none;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 0;
  overflow: hidden;
  animation: slideDown 0.3s ease;
  z-index: 10000;
  background: white;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Dropdown Header */
.dropdown-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border: none !important;
  margin-bottom: 0 !important;
}

.dropdown-header i {
  font-size: 42px;
  opacity: 0.9;
  margin: 0;
}

.dropdown-header::after {
  display: none !important;
}

.user-email-text {
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  word-break: break-word;
  opacity: 0.95;
}

/* Modern Dropdown Items */
.modern-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #2d3748;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  border: none;
}

.modern-item:first-of-type {
  margin-top: 8px;
}

.modern-item:last-of-type {
  margin-bottom: 8px;
}

.modern-item:not(.logout-item) i,
.modern-item:not(.logout-item) i.fas,
.modern-item:not(.logout-item) i.far {
  font-size: 16px;
  width: 20px;
  color: #4a5568;
  transition: all 0.2s ease;
}

.modern-item:hover:not(.router-link-active):not(.logout-item) {
  background: linear-gradient(90deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
  color: #667eea;
  padding-left: 24px;
}

.modern-item:hover:not(.router-link-active):not(.logout-item) i {
  transform: scale(1.1);
  color: #667eea !important;
}

.modern-item.router-link-active:not(.logout-item),
.modern-item.router-link-exact-active:not(.logout-item) {
  background: none !important;
  color: #667eea !important;
  font-weight: 700 !important;
  padding-left: 20px !important;
}

.modern-item.router-link-active:not(.logout-item) i,
.modern-item.router-link-exact-active:not(.logout-item) i {
  color: #667eea !important;
}

/* Logout Item Special Styling */
.logout-item {
  color: #e53e3e !important;
}

.logout-item i {
  color: #e53e3e !important;
}

.logout-item:hover {
  background: rgba(229, 62, 62, 0.08);
  color: #c53030 !important;
}

.logout-item:hover i {
  color: #c53030 !important;
}

/* Dropdown Divider */
.modern-dropdown .dropdown-divider {
  margin: 8px 0;
  border-color: rgba(0, 0, 0, 0.06);
  height: 1px;
}

.modern-dropdown .dropdown-divider:first-of-type {
  display: none !important;
}

/* Remove duplicate dividers */
.modern-dropdown .dropdown-divider + .dropdown-divider {
  display: none;
}

/* Remove border after header */
.dropdown-header + * {
  border-top: none !important;
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/Header.vue